import type { ComponentProps } from 'react';
import { cn } from '@savvy-kit/lib/utils';

export default function AdvisorDashboardCard({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('overflow-hidden rounded-md border border-border-light bg-card', className)} {...props} />;
}
